import FormatDate from '@/services/format-date-service';
import * as types from './follow-official-accounts-types';

export default {
  // 设置二维码
  [types.SET_QRCODE](state, { qrcode }) {
    state.qrcode = qrcode;
    localStorage.setItem('qrcode', qrcode);
  },

  // 初始化QRcode
  [types.INIT_QRCODE](state) {
    if (localStorage.getItem('qrcode')) {
      state.qrcode = localStorage.getItem('qrcode');
    } else {
      state.qrcode = '';
    }
  },

  // 退出清空qrcode
  [types.CLEAN_QRCODE](state) {
    state.qrcode = '';
    localStorage.setItem('qrcode', '');
  },

  // 切换二维码弹窗状态
  [types.SWITCH_MODAL_SHOW](state, { show }) {
    state.qrcodeModalShow = show;
  },

  // 初始化qrcodeShow和closeDate isLogin mp_watch
  [types.INIT_QRCODE_STA](state, routeParams) {
    state.closeDate = localStorage.getItem('closeDate');
    state.isLogin = +localStorage.getItem('isLogin');
    state.mp_watch = +localStorage.getItem('mp_watch');

    if (!state.isLogin) return state.qrcodeModalShow = false;

    if (state.mp_watch) return state.qrcodeModalShow = false;

    if (routeParams && routeParams.currentRouteName === 'bind') return state.qrcodeModalShow = false;

    if (!state.closeDate) {
      state.qrcodeModalShow = true;
    } else {
      if (!state.payok) {
        if ((new Date(FormatDate.formatDate(new Date())) - new Date(state.closeDate)) / (1000 * 3600 * 24) > 14) {
          state.qrcodeModalShow = true;
        } else {
          state.qrcodeModalShow = false;
        }
      }
    }
  },

  // 保存在非订单详情页关闭二维码弹窗的日期
  [types.SAVE_CLOSE_DATE](state, { date }) {
    state.closeDate = date;
    localStorage.setItem('closeDate', date);
  },

  // 保存用户是否关注公众号的状态
  [types.SAVE_MP_WATCH](state, { mp_watch }) {
    state.mp_watch = mp_watch;
    localStorage.setItem('mp_watch', mp_watch);
  },

  // 切换登录状态
  [types.IS_LOGIN](state, { isLogin }) {
    state.isLogin = isLogin;
    localStorage.setItem('isLogin', isLogin);
  },

  // 支付成功
  [types.PAY_OK](state, { payok }) {
    state.payok = payok;
  },

  // 用于订单支付成功后
  [types.IS_SHOW_MODAL](state, { name }) {
    if (state.isLogin && !state.mp_watch) {
      if (name !== 'bind') {
        if (!state.closeDate) {
          state.qrcodeModalShow = true;
        } else {
          if (name === 'orderDetail' && !state.payok) {
            if ((new Date(FormatDate.formatDate(new Date())) - new Date(state.closeDate)) / (1000 * 3600 * 24) > 14) {
              state.qrcodeModalShow = true;
            } else {
              state.qrcodeModalShow = false;
            }
          }
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/follow-official-accounts/follow-official-accounts-mutations.js